export default "__VITE_ASSET__g4hcIy4l__"